














import Vue from 'vue'
export default Vue.extend({
  name: 'IconRefresh',
  props: {
    color: {
      type: String,
      default: '#0090da',
    },
  },
})
